import { Component, OnInit, Input } from '@angular/core';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
  selector: 'app-navegacion',
  templateUrl: './navegacion.component.html',
  styleUrls: ['./navegacion.component.scss']
})
export class NavegacionComponent implements OnInit {
	isOpen = true;

  constructor() { }

  ngOnInit() {
  }

  navOpen($event): void {
    // toggle condition here
    this.isOpen = !this.isOpen;
    // console.log(this.isOpen);
  }

}
